import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * パスワード変更要求API
 */
export const requestForChange = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PW/001', r).catch(handleError)
}

/**
 * 新パスワード登録API
 */
export const registerNew = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PW/002', r).catch(handleError)
}
